import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';
import {CockpitCard} from 'shared/dtos/cockpit-card';
import {CockpitM2} from 'shared/dtos/cockpit/cockpit';
import {
  PersonenGesamtesUnternehmen,
  PersonenNachCodierungM1,
  PersonenNachFunktionM1,
  PersonenNachFunktionM2
} from 'shared/dtos/cockpit/funktionenstatistiken';
import {FunctionRating} from 'shared/dtos/function-rating';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {CockpitContentComponent} from '../../cockpit-content-component';

@Component({
  selector: 'app-chart-dialog-funktionenstatistiken-personen',
  templateUrl: './chart-dialog-funktionenstatistiken-personen.component.html',
  styleUrls: [
    './chart-dialog-funktionenstatistiken-personen.component.scss',
    '../cockpit-styles.scss'
  ],
  standalone: false
})
export class ChartDialogFunktionenstatistikenPersonenComponent
  extends CurrentLocaleComponent
  implements OnInit, CockpitContentComponent
{
  card: CockpitCard;
  chart: Highcharts.Chart;
  isDebug = false;
  gesamtesUnternehmen: PersonenGesamtesUnternehmen;
  nachFunktion: PersonenNachFunktionM1[] | PersonenNachFunktionM2[];
  nachCodierung: PersonenNachCodierungM1[];
  funktionen: FunctionRating[];
  isForM2 = false;

  constructor(
    protected readonly translate: TranslateService,
    private readonly storage: DataStorageService,
    private readonly tableExport: TableExportService
  ) {
    super(translate);
  }

  async ngOnInit() {
    super.ngOnInit();
    this.isDebug = await this.storage.getDebug();
    this.isForM2 = await this.storage.getIsForModule2();
    await this.initializeData();
  }

  exportTable1() {
    const cardTitle = this.translate.instant(
      'm1.sprint9.cockpit.card.funktionenstatistiken.personer.fn.subtitle'
    );
    this.tableExport.exportHtmlTable('funkstat-personen.fn', cardTitle);
  }

  exportTable2() {
    const cardTitle = this.translate.instant(
      'm1.sprint9.cockpit.card.funktionenstatistiken.bst-anf.subtitle'
    );
    this.tableExport.exportHtmlTable('funkstat-personen.bst-anf', cardTitle);
  }

  debugManipulateFunktionensLoehne(action: string) {
    switch (action) {
      case 'anteil':
        this.nachFunktion?.forEach(item => {
          item.anteilMaenner = null;
          item.anteilFrauen = null;
        });
        break;
      case 'anzahl':
        this.nachFunktion?.forEach(item => {
          item.anzahlMaenner = null;
          item.anzahlFrauen = null;
        });
        break;
      default:
        this.initializeData();
        break;
    }
  }

  private async initializeData() {
    this.funktionen = await this.storage.getFunktionen();
    const fncStatistiksPersonen = (
      (await this.storage.getCockpitData()) as CockpitM2
    )?.funktionenstatistiken;
    this.nachFunktion = fncStatistiksPersonen?.personen?.nachFunktion;
    this.nachCodierung = fncStatistiksPersonen?.personen?.nachCodierung;
    this.gesamtesUnternehmen =
      fncStatistiksPersonen?.personen?.gesamtesUnternehmen;
  }
}
